var map = {
	"./512rYUX2xarV.jpg": 5845,
	"./5CGjQgnyDO2f.jpg": 6493,
	"./9BfoSQlwAv7k.jpg": 6494,
	"./9bmyfObApgWi.webp": 8800,
	"./IyidqtZcJKFh.jpeg": 7951,
	"./MSBE1Ez2sY63.jpg": 5422,
	"./RYJmrmoLCkqa.jpeg": 669,
	"./bFdo0Rm68y1r.jpeg": 6103,
	"./champions-league.png": 5752,
	"./dY334gLQSUs3.jpg": 5901,
	"./eredivisie.jpg": 931,
	"./htqK9bGsp4pe.jpg": 3748,
	"./oFKhvss8oBJ7.webp": 8002,
	"./p5apiXaboZk6.jpg": 7838,
	"./qT0xgGPjjPIm.jpg": 6213,
	"./tGzAOEYf7zsk.jpg": 9274,
	"./up9AUM5UmJ7Z.jpeg": 9958,
	"./vAeogBTAMZ34.jpeg": 2440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5360;